export const BaseUrl = "https://api.tiaraawellness.com/";
// export const BaseUrl = "http://localhost:8006/";
